const products = [
  // == Suits & Blazers ==
  {
    id: 1,
    name: "Navy Blue Blazer",
    description:
      "Tailored navy blue blazer made from premium wool blend fabric.",
    price: 30000,
    salePrice: 25000,
    onSale: true,
    image: "/products/suits/item-1.jpg",
    category: "suits",
    sizes: ["S", "M", "L", "XL"],
    colors: ["navy", "black"],
    isFeatured: true,
    rating: 4.6,
    stock: 15,
  },
  {
    id: 2,
    name: "Gray Suit",
    description: "Classic gray suit with a modern slim fit design.",
    price: 45000,
    onSale: false,
    image: "/products/suits/item-2.jpg",
    category: "suits",
    sizes: ["M", "L", "XL", "XXL"],
    colors: ["gray", "black"],
    isFeatured: false,
    rating: 4.8,
    stock: 10,
  },
  {
    id: 3,
    name: "Black Tuxedo",
    description: "Elegant black tuxedo perfect for formal occasions.",
    price: 60000,
    salePrice: 52000,
    onSale: true,
    image: "/products/suits/item-3.jpg",
    category: "suits",
    sizes: ["M", "L", "XL"],
    colors: ["black"],
    isFeatured: true,
    rating: 4.9,
    stock: 8,
  },
  {
    id: 4,
    name: "Beige Linen Suit",
    description: "Lightweight beige linen suit, great for summer events.",
    price: 40000,
    onSale: false,
    image: "/products/suits/item-4.jpg",
    category: "suits",
    sizes: ["S", "M", "L"],
    colors: ["beige", "cream"],
    isFeatured: false,
    rating: 4.4,
    stock: 12,
  },
  {
    id: 5,
    name: "Charcoal Blazer",
    description: "Versatile charcoal blazer for both casual and office wear.",
    price: 28000,
    salePrice: 24000,
    onSale: true,
    image: "/products/suits/item-5.jpg",
    category: "suits",
    sizes: ["M", "L", "XL"],
    colors: ["charcoal", "black"],
    isFeatured: false,
    rating: 4.5,
    stock: 20,
  },
  {
    id: 6,
    name: "Double-Breasted Navy Suit",
    description: "Sharp double-breasted navy suit with peak lapels.",
    price: 55000,
    onSale: false,
    image: "/products/suits/item-6.jpg",
    category: "suits",
    sizes: ["M", "L", "XL", "XXL"],
    colors: ["navy"],
    isFeatured: true,
    rating: 4.7,
    stock: 9,
  },
  {
    id: 7,
    name: "Slim Fit Maroon Blazer",
    description: "Bold slim-fit maroon blazer for standout looks.",
    price: 32000,
    salePrice: 28000,
    onSale: true,
    image: "/products/suits/item-7.jpg",
    category: "suits",
    sizes: ["S", "M", "L"],
    colors: ["maroon", "black"],
    isFeatured: false,
    rating: 4.3,
    stock: 14,
  },
  {
    id: 8,
    name: "Classic Pinstripe Suit",
    description: "Timeless gray pinstripe suit for business and formal wear.",
    price: 48000,
    onSale: false,
    image: "/products/suits/item-8.jpg",
    category: "suits",
    sizes: ["M", "L", "XL"],
    colors: ["gray"],
    isFeatured: false,
    rating: 4.6,
    stock: 11,
  },
  {
    id: 9,
    name: "Velvet Dinner Jacket",
    description: "Luxurious black velvet dinner jacket with satin lapel.",
    price: 37000,
    salePrice: 33000,
    onSale: true,
    image: "/products/suits/item-9.jpg",
    category: "suits",
    sizes: ["M", "L"],
    colors: ["black"],
    isFeatured: true,
    rating: 4.8,
    stock: 7,
  },
  {
    id: 10,
    name: "Light Blue Suit",
    description: "Fresh light blue suit ideal for weddings and celebrations.",
    price: 42000,
    onSale: false,
    image: "/products/suits/item-10.jpg",
    category: "suits",
    sizes: ["S", "M", "L", "XL"],
    colors: ["light blue", "white"],
    isFeatured: false,
    rating: 4.5,
    stock: 13,
  },

  // === Tops ===
  {
    id: 11,
    name: "Classic White T-Shirt",
    description:
      "Unisex cotton T-shirt with a relaxed fit, perfect for casual wear.",
    price: 5500,
    salePrice: 4500,
    onSale: true,
    image: "/products/tops/item-1.jpg",
    category: "tops",
    sizes: ["S", "M", "L", "XL"],
    colors: ["white", "black", "blue"],
    isFeatured: true,
    rating: 4.5,
    stock: 30,
  },
  {
    id: 12,
    name: "Black Hoodie",
    description: "Comfortable fleece-lined hoodie suitable for all genders.",
    price: 12000,
    onSale: false,
    image: "/products/tops/item-2.jpg",
    category: "tops",
    sizes: ["M", "L", "XL"],
    colors: ["black", "grey"],
    isFeatured: false,
    rating: 4.7,
    stock: 18,
  },
  {
    id: 13,
    name: "Striped Polo Shirt",
    description: "Smart casual striped polo shirt made from breathable cotton.",
    price: 8500,
    salePrice: 7000,
    onSale: true,
    image: "/products/tops/item-3.jpg",
    category: "tops",
    sizes: ["S", "M", "L", "XL"],
    colors: ["navy", "white"],
    isFeatured: false,
    rating: 4.4,
    stock: 22,
  },
  {
    id: 14,
    name: "Denim Shirt",
    description: "Casual button-up denim shirt with long sleeves.",
    price: 15000,
    onSale: false,
    image: "/products/tops/item-4.jpg",
    category: "tops",
    sizes: ["M", "L", "XL"],
    colors: ["blue"],
    isFeatured: true,
    rating: 4.6,
    stock: 15,
  },
  {
    id: 15,
    name: "Graphic Tee",
    description: "Trendy unisex graphic T-shirt with bold print design.",
    price: 6500,
    salePrice: 5500,
    onSale: true,
    image: "/products/tops/item-5.jpg",
    category: "tops",
    sizes: ["S", "M", "L"],
    colors: ["white", "black"],
    isFeatured: false,
    rating: 4.3,
    stock: 28,
  },
  {
    id: 16,
    name: "Plaid Flannel Shirt",
    description: "Classic plaid flannel shirt for a rugged casual style.",
    price: 11000,
    onSale: false,
    image: "/products/tops/item-6.jpg",
    category: "tops",
    sizes: ["M", "L", "XL"],
    colors: ["red", "black", "green"],
    isFeatured: false,
    rating: 4.5,
    stock: 17,
  },
  {
    id: 17,
    name: "Oversized Sweatshirt",
    description: "Relaxed-fit oversized sweatshirt with dropped shoulders.",
    price: 13500,
    salePrice: 12000,
    onSale: true,
    image: "/products/tops/item-7.jpg",
    category: "tops",
    sizes: ["S", "M", "L", "XL"],
    colors: ["grey", "navy"],
    isFeatured: true,
    rating: 4.6,
    stock: 20,
  },
  {
    id: 18,
    name: "Formal Dress Shirt",
    description: "Slim-fit white dress shirt, ideal for formal events.",
    price: 18000,
    onSale: false,
    image: "/products/tops/item-8.jpg",
    category: "tops",
    sizes: ["M", "L", "XL", "XXL"],
    colors: ["white"],
    isFeatured: false,
    rating: 4.7,
    stock: 12,
  },
  {
    id: 19,
    name: "Henley Shirt",
    description: "Casual long-sleeve Henley with button placket.",
    price: 9000,
    onSale: false,
    image: "/products/tops/item-9.jpg",
    category: "tops",
    sizes: ["S", "M", "L"],
    colors: ["olive", "black", "white"],
    isFeatured: false,
    rating: 4.4,
    stock: 19,
  },
  {
    id: 20,
    name: "V-Neck T-Shirt",
    description: "Soft cotton V-neck T-shirt for everyday wear.",
    price: 6000,
    salePrice: 5000,
    onSale: true,
    image: "/products/tops/item-10.jpg",
    category: "tops",
    sizes: ["S", "M", "L", "XL"],
    colors: ["blue", "white"],
    isFeatured: false,
    rating: 4.2,
    stock: 25,
  },

  // === Bottoms ===
  {
    id: 21,
    name: "Blue Denim Jeans",
    description:
      "Straight-leg denim jeans designed for both comfort and durability.",
    price: 15000,
    salePrice: 13000,
    onSale: true,
    image: "/products/bottoms/item-1.jpg",
    category: "bottoms",
    sizes: ["30", "32", "34", "36"],
    colors: ["blue"],
    isFeatured: true,
    rating: 4.2,
    stock: 25,
  },
  {
    id: 22,
    name: "Chinos Trousers",
    description: "Slim-fit chinos suitable for casual and semi-formal looks.",
    price: 14000,
    onSale: false,
    image: "/products/bottoms/item-2.jpg",
    category: "bottoms",
    sizes: ["30", "32", "34", "36"],
    colors: ["khaki", "black", "navy"],
    isFeatured: false,
    rating: 4.4,
    stock: 20,
  },
  {
    id: 23,
    name: "Black Skinny Jeans",
    description:
      "Trendy black skinny jeans with stretch fabric for flexibility.",
    price: 16000,
    salePrice: 14500,
    onSale: true,
    image: "/products/bottoms/item-3.jpg",
    category: "bottoms",
    sizes: ["28", "30", "32", "34"],
    colors: ["black"],
    isFeatured: false,
    rating: 4.5,
    stock: 18,
  },
  {
    id: 24,
    name: "Cargo Pants",
    description: "Utility cargo pants with multiple pockets and relaxed fit.",
    price: 15500,
    onSale: false,
    image: "/products/bottoms/item-4.jpg",
    category: "bottoms",
    sizes: ["30", "32", "34", "36", "38"],
    colors: ["olive", "khaki"],
    isFeatured: true,
    rating: 4.3,
    stock: 22,
  },
  {
    id: 25,
    name: "Formal Dress Pants",
    description: "Classic slim-fit trousers suitable for office and events.",
    price: 17000,
    onSale: false,
    image: "/products/bottoms/item-5.jpg",
    category: "bottoms",
    sizes: ["30", "32", "34", "36"],
    colors: ["black", "grey", "navy"],
    isFeatured: false,
    rating: 4.6,
    stock: 15,
  },
  {
    id: 26,
    name: "Jogger Pants",
    description: "Comfortable joggers with elastic cuffs and adjustable waist.",
    price: 12000,
    salePrice: 10000,
    onSale: true,
    image: "/products/bottoms/item-6.jpg",
    category: "bottoms",
    sizes: ["S", "M", "L", "XL"],
    colors: ["grey", "black"],
    isFeatured: false,
    rating: 4.4,
    stock: 30,
  },
  {
    id: 27,
    name: "Wide-Leg Trousers",
    description: "Elegant wide-leg trousers crafted from lightweight fabric.",
    price: 18000,
    onSale: false,
    image: "/products/bottoms/item-7.jpg",
    category: "bottoms",
    sizes: ["M", "L", "XL"],
    colors: ["beige", "white"],
    isFeatured: true,
    rating: 4.5,
    stock: 12,
  },
  {
    id: 28,
    name: "Ripped Jeans",
    description: "Casual ripped denim jeans with a modern streetwear style.",
    price: 16000,
    salePrice: 14000,
    onSale: true,
    image: "/products/bottoms/item-8.jpg",
    category: "bottoms",
    sizes: ["28", "30", "32", "34", "36"],
    colors: ["blue", "black"],
    isFeatured: false,
    rating: 4.2,
    stock: 20,
  },
  {
    id: 29,
    name: "Tailored Wool Pants",
    description: "Premium wool trousers designed for comfort and elegance.",
    price: 20000,
    onSale: false,
    image: "/products/bottoms/item-9.jpg",
    category: "bottoms",
    sizes: ["30", "32", "34", "36"],
    colors: ["grey", "charcoal"],
    isFeatured: true,
    rating: 4.7,
    stock: 10,
  },
  {
    id: 30,
    name: "Linen Drawstring Pants",
    description: "Lightweight linen trousers with a relaxed, airy fit.",
    price: 13000,
    onSale: false,
    image: "/products/bottoms/item-10.jpg",
    category: "bottoms",
    sizes: ["S", "M", "L", "XL"],
    colors: ["white", "beige"],
    isFeatured: false,
    rating: 4.3,
    stock: 16,
  },

  // === Footwear ===
  {
    id: 31,
    name: "Casual Sneakers",
    description: "Lightweight sneakers with cushioned soles for everyday use.",
    price: 18000,
    salePrice: 15000,
    onSale: true,
    image: "/products/footwear/item-1.jpg",
    category: "footwear",
    sizes: ["40", "41", "42", "43", "44"],
    colors: ["white", "black"],
    isFeatured: true,
    rating: 4.6,
    stock: 15,
  },
  {
    id: 32,
    name: "Leather Loafers",
    description: "Premium loafers handcrafted from genuine leather.",
    price: 25000,
    onSale: false,
    image: "/products/footwear/item-2.jpg",
    category: "footwear",
    sizes: ["40", "41", "42", "43", "44", "45"],
    colors: ["brown", "black"],
    isFeatured: false,
    rating: 4.8,
    stock: 10,
  },
  {
    id: 33,
    name: "Running Shoes",
    description: "Breathable running shoes designed for maximum performance.",
    price: 22000,
    onSale: false,
    image: "/products/footwear/item-3.jpg",
    category: "footwear",
    sizes: ["39", "40", "41", "42", "43", "44"],
    colors: ["blue", "black", "grey"],
    isFeatured: true,
    rating: 4.5,
    stock: 20,
  },
  {
    id: 34,
    name: "High-Top Sneakers",
    description: "Trendy high-top sneakers for a bold streetwear look.",
    price: 20000,
    salePrice: 17500,
    onSale: true,
    image: "/products/footwear/item-4.jpg",
    category: "footwear",
    sizes: ["40", "41", "42", "43"],
    colors: ["black", "red", "white"],
    isFeatured: false,
    rating: 4.4,
    stock: 18,
  },
  {
    id: 35,
    name: "Formal Oxford Shoes",
    description: "Classic oxford shoes made from polished leather.",
    price: 30000,
    onSale: false,
    image: "/products/footwear/item-5.jpg",
    category: "footwear",
    sizes: ["40", "41", "42", "43", "44"],
    colors: ["black", "brown"],
    isFeatured: true,
    rating: 4.9,
    stock: 12,
  },
  {
    id: 36,
    name: "Flip Flops",
    description: "Lightweight flip flops suitable for casual wear.",
    price: 5000,
    onSale: false,
    image: "/products/footwear/item-6.jpg",
    category: "footwear",
    sizes: ["39", "40", "41", "42", "43", "44"],
    colors: ["red", "blue", "yellow"],
    isFeatured: false,
    rating: 4.1,
    stock: 40,
  },
  {
    id: 37,
    name: "Chelsea Boots",
    description: "Stylish ankle-length Chelsea boots in suede leather.",
    price: 28000,
    onSale: false,
    image: "/products/footwear/item-7.jpg",
    category: "footwear",
    sizes: ["40", "41", "42", "43", "44", "45"],
    colors: ["brown", "black"],
    isFeatured: true,
    rating: 4.7,
    stock: 14,
  },
  {
    id: 38,
    name: "Sport Sandals",
    description:
      "Durable sandals with adjustable straps for outdoor activities.",
    price: 12000,
    salePrice: 10000,
    onSale: true,
    image: "/products/footwear/item-8.jpg",
    category: "footwear",
    sizes: ["39", "40", "41", "42", "43", "44"],
    colors: ["purple", "black"],
    isFeatured: false,
    rating: 4.3,
    stock: 22,
  },
  {
    id: 39,
    name: "Leather Derby Shoes",
    description: "Elegant derby shoes suitable for formal occasions.",
    price: 27000,
    onSale: false,
    image: "/products/footwear/item-9.jpg",
    category: "footwear",
    sizes: ["40", "41", "42", "43", "44"],
    colors: ["black", "tan"],
    isFeatured: false,
    rating: 4.8,
    stock: 11,
  },
  {
    id: 40,
    name: "Slip-On Canvas Shoes",
    description: "Casual slip-on shoes with breathable canvas fabric.",
    price: 15000,
    onSale: false,
    image: "/products/footwear/item-10.jpg",
    category: "footwear",
    sizes: ["39", "40", "41", "42", "43"],
    colors: ["navy", "white", "black"],
    isFeatured: false,
    rating: 4.2,
    stock: 28,
  },

  // === Accessories ===
  {
    id: 41,
    name: "Leather Belt",
    description:
      "Genuine leather belt with adjustable buckle, suitable for any outfit.",
    price: 5500,
    onSale: false,
    image: "/products/accessories/item-1.jpg",
    category: "accessories",
    sizes: ["M", "L", "XL"],
    colors: ["black", "brown"],
    isFeatured: false,
    rating: 4.3,
    stock: 40,
  },
  {
    id: 42,
    name: "Gold Chain Necklace",
    description: "Elegant 18k gold-plated chain with a sleek modern design.",
    price: 22000,
    onSale: false,
    image: "/products/accessories/item-2.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["gold"],
    isFeatured: true,
    rating: 4.7,
    stock: 12,
  },
  {
    id: 43,
    name: "Silver Bracelet",
    description:
      "Stylish unisex bracelet crafted from polished sterling silver.",
    price: 15000,
    salePrice: 12000,
    onSale: true,
    image: "/products/accessories/item-3.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["silver"],
    isFeatured: false,
    rating: 4.5,
    stock: 20,
  },
  {
    id: 44,
    name: "Wrist Watch - Classic Black",
    description:
      "Minimalist wristwatch with black leather strap and stainless steel case.",
    price: 30000,
    onSale: false,
    image: "/products/accessories/item-4.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["black", "silver"],
    isFeatured: true,
    rating: 4.8,
    stock: 8,
  },
  {
    id: 45,
    name: "Pearl Earrings",
    description: "Timeless pearl earrings with a delicate gold-plated base.",
    price: 10000,
    onSale: false,
    image: "/products/accessories/item-5.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["white", "gold"],
    isFeatured: false,
    rating: 4.4,
    stock: 25,
  },
  {
    id: 46,
    name: "Beaded Bracelet",
    description: "Handcrafted bracelet made from natural gemstone beads.",
    price: 7500,
    salePrice: 6000,
    onSale: true,
    image: "/products/accessories/item-6.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["multicolor"],
    isFeatured: false,
    rating: 4.2,
    stock: 30,
  },
  {
    id: 47,
    name: "Aviator Sunglasses",
    description: "Classic aviator sunglasses with UV-protection lenses.",
    price: 12000,
    onSale: false,
    image: "/products/accessories/item-7.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["black", "gold"],
    isFeatured: true,
    rating: 4.6,
    stock: 18,
  },
  {
    id: 48,
    name: "Leather Wallet",
    description: "Compact and durable wallet made from 100% genuine leather.",
    price: 8500,
    onSale: false,
    image: "/products/accessories/item-8.jpg",
    category: "accessories",
    sizes: ["One Size"],
    colors: ["brown", "black"],
    isFeatured: false,
    rating: 4.5,
    stock: 35,
  },
  {
    id: 49,
    name: "Smartwatch Band",
    description: "Replacement smartwatch band made with breathable silicone.",
    price: 5000,
    onSale: false,
    image: "/products/accessories/item-9.jpg",
    category: "accessories",
    sizes: ["S", "M", "L"],
    colors: ["black", "blue", "pink"],
    isFeatured: false,
    rating: 4.1,
    stock: 50,
  },
  {
    id: 50,
    name: "Gold-Plated Bangle",
    description: "Chic and durable gold-plated bangle for everyday elegance.",
    price: 13000,
    salePrice: 11000,
    onSale: true,
    image: "/products/accessories/item-10.jpg",
    category: "accessories",
    sizes: ["S", "M", "L"],
    colors: ["gold"],
    isFeatured: true,
    rating: 4.7,
    stock: 15,
  },

  // === Native Wear ===
  {
    id: 51,
    name: "Ankara Fabric",
    description:
      "Vibrant African Ankara fabric designed for comfort and elegance.",
    price: 20000,
    salePrice: 17000,
    onSale: true,
    image: "/products/native/item-1.jpg",
    category: "native",
    sizes: ["6yd"],
    colors: ["multicolor"],
    isFeatured: true,
    rating: 4.5,
    stock: 12,
  },
  {
    id: 52,
    name: "Agbada Set",
    description:
      "Traditional agbada set with embroidery, perfect for special occasions.",
    price: 45000,
    onSale: false,
    image: "/products/native/item-2.jpg",
    category: "native",
    sizes: ["M", "L", "XL", "XXL"],
    colors: ["white", "navy", "cream"],
    isFeatured: false,
    rating: 4.7,
    stock: 8,
  },
  {
    id: 53,
    name: "Kaftan",
    description: "Elegant kaftan with detailed embroidery along the neckline.",
    price: 30000,
    salePrice: 27000,
    onSale: true,
    image: "/products/native/item-3.jpg",
    category: "native",
    sizes: ["M", "L", "XL"],
    colors: ["blue", "black", "white"],
    isFeatured: false,
    rating: 4.6,
    stock: 15,
  },
  {
    id: 54,
    name: "Isi Agu Shirt",
    description: "Cultural Igbo Isi Agu top with lion head patterns.",
    price: 25000,
    onSale: false,
    image: "/products/native/item-4.jpg",
    category: "native",
    sizes: ["M", "L", "XL"],
    colors: ["red", "black"],
    isFeatured: true,
    rating: 4.8,
    stock: 10,
  },
  {
    id: 55,
    name: "Senator Wear",
    description:
      "Modern senator style outfit with tailored fit and sleek design.",
    price: 35000,
    onSale: false,
    image: "/products/native/item-5.jpg",
    category: "native",
    sizes: ["M", "L", "XL", "XXL"],
    colors: ["wine", "navy", "gray"],
    isFeatured: false,
    rating: 4.4,
    stock: 18,
  },
  {
    id: 56,
    name: "Dashiki Shirt",
    description:
      "Unisex African dashiki shirt with vibrant multi-colored prints.",
    price: 12000,
    onSale: false,
    image: "/products/native/item-6.jpg",
    category: "native",
    sizes: ["S", "M", "L", "XL"],
    colors: ["multicolor"],
    isFeatured: false,
    rating: 4.3,
    stock: 25,
  },
  {
    id: 57,
    name: "George Wrapper Set",
    description:
      "Luxurious George wrapper with blouse, ideal for traditional events.",
    price: 40000,
    onSale: false,
    image: "/products/native/item-7.jpg",
    category: "native",
    sizes: ["One Size"],
    colors: ["blue", "gold"],
    isFeatured: true,
    rating: 4.6,
    stock: 7,
  },
  {
    id: 58,
    name: "Adire Fabric",
    description:
      "Hand-dyed Yoruba Adire fabric, 6 yards of pure cotton elegance.",
    price: 18000,
    salePrice: 15000,
    onSale: true,
    image: "/products/native/item-8.jpg",
    category: "native",
    sizes: ["6yd"],
    colors: ["indigo", "white"],
    isFeatured: false,
    rating: 4.5,
    stock: 20,
  },
  {
    id: 59,
    name: "Buba & Sokoto",
    description:
      "Classic Yoruba buba and sokoto set for both formal and casual wear.",
    price: 28000,
    onSale: false,
    image: "/products/native/item-9.jpg",
    category: "native",
    sizes: ["M", "L", "XL"],
    colors: ["white", "cream", "blue"],
    isFeatured: false,
    rating: 4.4,
    stock: 16,
  },
  {
    id: 60,
    name: "Head Tie (Gele)",
    description: "Traditional Nigerian gele made from aso-oke fabric.",
    price: 10000,
    salePrice: 8500,
    onSale: true,
    image: "/products/native/item-10.jpg",
    category: "native",
    sizes: ["One Size"],
    colors: ["gold", "red", "blue"],
    isFeatured: false,
    rating: 4.2,
    stock: 30,
  },

  // === Headwear ===
  {
    id: 61,
    name: "Fedora Hat",
    description: "Stylish fedora hat made from high-quality felt material.",
    price: 8000,
    salePrice: 7000,
    onSale: true,
    image: "/products/headwear/item-1.jpg",
    category: "headwear",
    sizes: ["S", "M", "L"],
    colors: ["black", "brown"],
    isFeatured: true,
    rating: 4.4,
    stock: 20,
  },
  {
    id: 62,
    name: "Beanie Hat",
    description: "Warm and cozy beanie hat, perfect for colder weather.",
    price: 4000,
    onSale: false,
    image: "/products/headwear/item-2.jpg",
    category: "headwear",
    sizes: ["One Size"],
    colors: ["grey", "black", "navy"],
    isFeatured: false,
    rating: 4.2,
    stock: 30,
  },
  {
    id: 63,
    name: "Baseball Cap",
    description: "Classic adjustable baseball cap for casual everyday wear.",
    price: 3500,
    onSale: false,
    image: "/products/headwear/item-3.jpg",
    category: "headwear",
    sizes: ["One Size"],
    colors: ["black", "white", "red", "blue"],
    isFeatured: false,
    rating: 4.3,
    stock: 40,
  },
  {
    id: 64,
    name: "Bucket Hat",
    description: "Trendy cotton bucket hat for sun protection and style.",
    price: 5000,
    salePrice: 4200,
    onSale: true,
    image: "/products/headwear/item-4.jpg",
    category: "headwear",
    sizes: ["M", "L"],
    colors: ["beige", "black", "olive"],
    isFeatured: false,
    rating: 4.5,
    stock: 25,
  },
  {
    id: 65,
    name: "Snapback Cap",
    description: "Modern snapback with adjustable closure and flat brim.",
    price: 4500,
    onSale: false,
    image: "/products/headwear/item-5.jpg",
    category: "headwear",
    sizes: ["One Size"],
    colors: ["black", "grey"],
    isFeatured: true,
    rating: 4.6,
    stock: 22,
  },
  {
    id: 66,
    name: "Straw Hat",
    description: "Lightweight straw hat ideal for sunny outdoor activities.",
    price: 6000,
    salePrice: 5000,
    onSale: true,
    image: "/products/headwear/item-6.jpg",
    category: "headwear",
    sizes: ["M", "L"],
    colors: ["natural", "brown"],
    isFeatured: false,
    rating: 4.1,
    stock: 18,
  },
  {
    id: 67,
    name: "Cowboy Hat",
    description: "Western-style cowboy hat with wide brim and durable build.",
    price: 12000,
    onSale: false,
    image: "/products/headwear/item-7.jpg",
    category: "headwear",
    sizes: ["M", "L", "XL"],
    colors: ["brown", "black"],
    isFeatured: true,
    rating: 4.7,
    stock: 12,
  },
  {
    id: 68,
    name: "Visor Cap",
    description:
      "Sporty visor cap perfect for tennis, golf, and outdoor events.",
    price: 3000,
    onSale: false,
    image: "/products/headwear/item-8.jpg",
    category: "headwear",
    sizes: ["One Size"],
    colors: ["white", "navy", "black", "red", "yellow"],
    isFeatured: false,
    rating: 4.0,
    stock: 28,
  },
  {
    id: 69,
    name: "Beret",
    description: "Chic wool beret offering a fashionable and classic look.",
    price: 7000,
    salePrice: 6000,
    onSale: true,
    image: "/products/headwear/item-9.jpg",
    category: "headwear",
    sizes: ["S", "M", "L"],
    colors: ["black", "red", "green", "pink", "orange"],
    isFeatured: false,
    rating: 4.4,
    stock: 15,
  },
  {
    id: 70,
    name: "Trucker Cap",
    description: "Casual trucker cap with breathable mesh back.",
    price: 3800,
    onSale: false,
    image: "/products/headwear/item-10.jpg",
    category: "headwear",
    sizes: ["One Size"],
    colors: ["black", "white", "blue", "green", "red", "pink"],
    isFeatured: false,
    rating: 4.2,
    stock: 35,
  },

  // === Bags ===
  {
    id: 71,
    name: "Leather Backpack",
    description:
      "Durable leather backpack with multiple compartments for everyday use.",
    price: 25000,
    salePrice: 22000,
    onSale: true,
    image: "/products/bags/item-1.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["brown", "black"],
    isFeatured: true,
    rating: 4.7,
    stock: 14,
  },
  {
    id: 72,
    name: "Canvas Tote Bag",
    description:
      "Eco-friendly canvas tote bag, perfect for shopping or casual outings.",
    price: 6000,
    onSale: false,
    image: "/products/bags/item-2.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["white", "black", "beige"],
    isFeatured: false,
    rating: 4.3,
    stock: 40,
  },
  {
    id: 73,
    name: "Crossbody Sling Bag",
    description: "Compact sling bag designed for convenience and mobility.",
    price: 12000,
    salePrice: 10000,
    onSale: true,
    image: "/products/bags/item-3.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["black", "navy"],
    isFeatured: false,
    rating: 4.5,
    stock: 20,
  },
  {
    id: 74,
    name: "Duffel Bag",
    description: "Spacious duffel bag suitable for travel or gym use.",
    price: 18000,
    onSale: false,
    image: "/products/bags/item-4.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["grey", "black"],
    isFeatured: true,
    rating: 4.6,
    stock: 12,
  },
  {
    id: 75,
    name: "Mini Handbag",
    description: "Trendy mini handbag for casual outings and events.",
    price: 15000,
    salePrice: 13000,
    onSale: true,
    image: "/products/bags/item-5.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["red", "black"],
    isFeatured: false,
    rating: 4.4,
    stock: 18,
  },
  {
    id: 76,
    name: "Messenger Bag",
    description:
      "Classic messenger bag with adjustable strap and laptop compartment.",
    price: 20000,
    onSale: false,
    image: "/products/bags/item-6.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["black", "brown"],
    isFeatured: false,
    rating: 4.2,
    stock: 16,
  },
  {
    id: 77,
    name: "Travel Backpack",
    description:
      "Large capacity backpack with padded straps for travel comfort.",
    price: 22000,
    onSale: false,
    image: "/products/bags/item-7.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["blue", "black"],
    isFeatured: true,
    rating: 4.8,
    stock: 10,
  },
  {
    id: 78,
    name: "Evening Clutch",
    description: "Elegant clutch bag with metallic accents for evening wear.",
    price: 12000,
    salePrice: 10000,
    onSale: true,
    image: "/products/bags/item-8.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["gold", "silver", "black"],
    isFeatured: false,
    rating: 4.5,
    stock: 22,
  },
  {
    id: 79,
    name: "Laptop Bag",
    description: "Protective laptop bag with padded interior and sleek design.",
    price: 17000,
    onSale: false,
    image: "/products/bags/item-9.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["black", "grey"],
    isFeatured: false,
    rating: 4.4,
    stock: 15,
  },
  {
    id: 80,
    name: "Drawstring Bag",
    description:
      "Lightweight drawstring bag suitable for casual use or sports.",
    price: 5000,
    onSale: false,
    image: "/products/bags/item-10.jpg",
    category: "bags",
    sizes: ["One Size"],
    colors: ["black", "blue", "red"],
    isFeatured: false,
    rating: 4.1,
    stock: 30,
  },

  // === bottoms continued (with skirts) ===
  {
    id: 81,
    name: "Pleated Skirt",
    description: "Classic pleated skirt with a chic and timeless design.",
    price: 12000,
    salePrice: 10000,
    onSale: true,
    image: "/products/bottoms/item-11.jpg",
    category: "bottoms",
    sizes: ["S", "M", "L", "XL"],
    colors: ["black", "pink", "beige"],
    isFeatured: false,
    rating: 4.4,
    stock: 18,
  },
  {
    id: 82,
    name: "Denim Skirt",
    description:
      "Trendy denim skirt, versatile for casual and semi-formal looks.",
    price: 15000,
    onSale: false,
    image: "/products/bottoms/item-12.jpg",
    category: "bottoms",
    sizes: ["S", "M", "L"],
    colors: ["blue", "light blue", "black"],
    isFeatured: true,
    rating: 4.5,
    stock: 22,
  },
  {
    id: 83,
    name: "Bodycon Skirt",
    description: "Fitted bodycon skirt for parties and stylish outings.",
    price: 14000,
    salePrice: 12500,
    onSale: true,
    image: "/products/bottoms/item-13.jpg",
    category: "bottoms",
    sizes: ["S", "M", "L"],
    colors: ["red", "black"],
    isFeatured: false,
    rating: 4.3,
    stock: 15,
  },
  {
    id: 84,
    name: "A-Line Skirt",
    description:
      "Comfortable A-line skirt perfect for both office and casual wear.",
    price: 13000,
    onSale: false,
    image: "/products/bottoms/item-14.jpg",
    category: "bottoms",
    sizes: ["S", "M", "L", "XL"],
    colors: ["green", "black", "brown"],
    isFeatured: false,
    rating: 4.1,
    stock: 19,
  },
  {
    id: 85,
    name: "Maxi Skirt",
    description:
      "Flowy maxi skirt with breathable fabric for comfort and elegance.",
    price: 17000,
    onSale: false,
    image: "/products/bottoms/item-15.jpg",
    category: "bottoms",
    sizes: ["M", "L", "XL"],
    colors: ["white", "floral", "navy"],
    isFeatured: true,
    rating: 4.6,
    stock: 12,
  },

  // === Gowns ===
  {
    id: 86,
    name: "Floral Summer Gown",
    description:
      "Lightweight floral gown perfect for casual outings and summer vibes.",
    price: 18000,
    salePrice: 16000,
    onSale: true,
    image: "/products/gowns/item-1.jpg",
    category: "gowns",
    sizes: ["S", "M", "L", "XL"],
    colors: ["yellow", "white", "pink"],
    isFeatured: true,
    rating: 4.5,
    stock: 15,
  },
  {
    id: 87,
    name: "Office Midi Gown",
    description:
      "Elegant midi gown designed for professional and smart-casual settings.",
    price: 22000,
    salePrice: null,
    onSale: false,
    image: "/products/gowns/item-2.jpg",
    category: "gowns",
    sizes: ["S", "M", "L"],
    colors: ["navy", "black", "gray"],
    isFeatured: false,
    rating: 4.3,
    stock: 18,
  },
  {
    id: 88,
    name: "Evening Satin Gown",
    description:
      "Luxurious satin gown with a sleek finish, perfect for dinners and events.",
    price: 45000,
    salePrice: 40000,
    onSale: true,
    image: "/products/gowns/item-3.jpg",
    category: "gowns",
    sizes: ["M", "L", "XL"],
    colors: ["red", "emerald", "black"],
    isFeatured: true,
    rating: 4.8,
    stock: 10,
  },
  {
    id: 89,
    name: "Casual T-Shirt Gown",
    description:
      "Relaxed-fit T-shirt gown, comfy and stylish for everyday wear.",
    price: 12000,
    salePrice: null,
    onSale: false,
    image: "/products/gowns/item-4.jpg",
    category: "gowns",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["white", "gray", "blue"],
    isFeatured: false,
    rating: 4.0,
    stock: 25,
  },
  {
    id: 90,
    name: "Party Sequin Gown",
    description: "Dazzling sequin gown for a glamorous party look.",
    price: 55000,
    salePrice: 50000,
    onSale: true,
    image: "/products/gowns/item-5.jpg",
    category: "gowns",
    sizes: ["S", "M", "L"],
    colors: ["silver", "gold", "black"],
    isFeatured: true,
    rating: 4.7,
    stock: 8,
  },
  {
    id: 91,
    name: "Wrap Style Gown",
    description:
      "Stylish wrap gown that flatters the figure with a modern silhouette.",
    price: 25000,
    salePrice: null,
    onSale: false,
    image: "/products/gowns/item-6.jpg",
    category: "gowns",
    sizes: ["S", "M", "L", "XL"],
    colors: ["teal", "maroon", "black"],
    isFeatured: false,
    rating: 4.4,
    stock: 12,
  },
  {
    id: 92,
    name: "Bohemian Maxi Gown",
    description:
      "Free-flowing maxi gown with bohemian prints, ideal for vacations.",
    price: 30000,
    salePrice: 27000,
    onSale: true,
    image: "/products/gowns/item-7.jpg",
    category: "gowns",
    sizes: ["M", "L", "XL"],
    colors: ["multicolor", "beige"],
    isFeatured: false,
    rating: 4.5,
    stock: 14,
  },
  {
    id: 93,
    name: "Bodycon Evening Gown",
    description:
      "Fitted bodycon gown that brings out a bold and confident look.",
    price: 35000,
    salePrice: null,
    onSale: false,
    image: "/products/gowns/item-8.jpg",
    category: "gowns",
    sizes: ["S", "M", "L"],
    colors: ["red", "black", "blue"],
    isFeatured: true,
    rating: 4.6,
    stock: 9,
  },
  {
    id: 94,
    name: "Denim Shirt Gown",
    description: "Trendy denim shirt-style gown that mixes casual and chic.",
    price: 20000,
    salePrice: 18000,
    onSale: true,
    image: "/products/gowns/item-9.jpg",
    category: "gowns",
    sizes: ["S", "M", "L", "XL"],
    colors: ["blue", "light blue"],
    isFeatured: false,
    rating: 4.1,
    stock: 20,
  },
  {
    id: 95,
    name: "Traditional Lace Gown",
    description:
      "Elegant lace gown with cultural flair, suitable for weddings and ceremonies.",
    price: 60000,
    salePrice: 55000,
    onSale: true,
    image: "/products/gowns/item-10.jpg",
    category: "gowns",
    sizes: ["M", "L", "XL"],
    colors: ["wine", "gold", "royal blue"],
    isFeatured: true,
    rating: 4.9,
    stock: 7,
  },

  //=== footwear continued (with heels) ===
  {
    id: 96,
    name: "Classic Black Heels",
    description: "Elegant stiletto heels perfect for formal and evening occasions.",
    price: 28000,
    salePrice: 25000,
    onSale: true,
    image: "/products/footwear/item-11.jpg",
    category: "footwear",
    sizes: ["37", "38", "39", "40", "41"],
    colors: ["black", "nude"],
    isFeatured: true,
    rating: 4.6,
    stock: 12,
  },
  {
    id: 97,
    name: "Block Heel Sandals",
    description: "Comfortable block heel sandals, stylish yet easy to walk in.",
    price: 22000,
    salePrice: null,
    onSale: false,
    image: "/products/footwear/item-12.jpg",
    category: "footwear",
    sizes: ["36", "37", "38", "39", "40", "41"],
    colors: ["beige", "brown", "black"],
    isFeatured: false,
    rating: 4.3,
    stock: 18,
  },
  {
    id: 98,
    name: "Ankle Strap Heels",
    description: "Trendy ankle strap heels for parties and stylish outings.",
    price: 26000,
    salePrice: 24000,
    onSale: true,
    image: "/products/footwear/item-13.jpg",
    category: "footwear",
    sizes: ["37", "38", "39", "40", "41", "42"],
    colors: ["gold", "white", "black"],
    isFeatured: true,
    rating: 4.5,
    stock: 14,
  },
  {
    id: 99,
    name: "Peep Toe Heels",
    description: "Chic peep toe heels with a modern design and comfortable sole.",
    price: 24000,
    salePrice: null,
    onSale: false,
    image: "/products/footwear/item-14.jpg",
    category: "footwear",
    sizes: ["36", "37", "38", "39", "40"],
    colors: ["red", "silver", "black"],
    isFeatured: false,
    rating: 4.2,
    stock: 16,
  },
  {
    id: 100,
    name: "Platform High Heels",
    description: "Bold platform high heels that add height and confidence.",
    price: 32000,
    salePrice: 30000,
    onSale: true,
    image: "/products/footwear/item-15.jpg",
    category: "footwear",
    sizes: ["37", "38", "39", "40", "41"],
    colors: ["pink", "blue", "black"],
    isFeatured: true,
    rating: 4.7,
    stock: 10,
  },

  // === Special Offers ===
  {
    id: 101,
    name: "Winter Cardigan",
    description:
      "Insulated winter cardigan with soft exterior and warm lining.",
    price: 18500,
    salePrice: 12500,
    onSale: true,
    image: "/products/special/item-1.jpg",
    category: "special",
    sizes: ["M", "L", "XL", "XXL"],
    colors: ["purple", "black", "grey"],
    isFeatured: true,
    rating: 4.7,
    stock: 10,
  },
];

export default products;
